<template>
  <div class="no-data text-center py-5">
    <i class="bi bi-inbox display-1 text-secondary mb-3"></i>
    <h4 class="text-secondary">{{ $t("popups.no_data") }}</h4>
  </div>
</template>

<script>
export default {
  name: "NoData",
};
</script>

<style scoped>
.no-data {
  background-color: #f8f9fa;
  border-radius: 8px;
  margin: 20px 0;
}
</style>
